// extracted by mini-css-extract-plugin
export default {"wrapper":"SignIn_wrapper__Xjj+a","header":"SignIn_header__TCMTL","card":"SignIn_card__I1Zws","companyName":"SignIn_companyName__yAaRB"};